import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _AbReactServicesInitializer;
/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbBannerProvider } from "abreact/app/banner/AbBannerProvider";
import { BuiltInUserSettings } from "abreact/app/settings/BuiltInUserSettings";
import { AbDefaultThemingService } from "abreact/app/theming/AbDefaultThemingService";
import { StandardPageStateStorageService } from "abreact/core/pagestate/StandardPageStateStorageService";
import { DataValueViews } from "abreact/data/DataValueViews";
import { PopupUtils } from "abreact/incubator/ui/popup/PopupUtils";
import { AbReactConstants } from "abreact/service/AbReactConstants";
import { AbReactServices } from "abreact/service/AbReactServices";
import { AbWebServices } from "abweb/service/AbWebServices";
import { LogUtils } from "abweb/utils/log/LogUtils";
import { ModuleLoaderUtils } from "abweb/utils/ModuleLoaderUtils";
export class AbReactServicesInitializer {
  static async initDefaultServices(override) {
    this.initializeFocusVisibleHandler();
    const themingService = override?.themingService || new AbDefaultThemingService();
    const importSpec = override?.defaultOwnerPopupFunctionSpec;
    await this.configurePopupOwnerStrategy(importSpec);
    DataValueViews.registerBuiltInDataValueViews();
    const bannerProvider = override?.bannerProvider || new AbBannerProvider();
    const pageStateStorageService = override?.pageStateStorageService || new StandardPageStateStorageService(30);
    // add app-specific configuration to abweb i18n and component registry
    await AbWebServices.localeService.loadResourceBundles(["webapp/abreact/assets/locale/{locale}/abreact.json"], []);
    // @ts-ignore: noUnusedLocals
    new AbReactServices(bannerProvider, themingService, pageStateStorageService);
    void AbReactServicesInitializer.prefetchErrorDialogResources(); // explicitly not waiting for prefetch images to complete

    BuiltInUserSettings.registerSettings();
    await themingService.initServices();
  }

  /**
   * Initializes event handlers for the ab-focus-visible class. Duplicated in compIndex.ejs for iframes.
   */

  // Pre-fetch error dialog resources so that they can still be read from cache on server disconnect
  static prefetchErrorDialogResources() {
    const dialogImageIds = new Set(["absdk:cancel", "absdk:arrow-left", "absdk:arrow-right", "absdk:download", "absdk:error", "absdk:info", "absdk:warning", "absdk:success", "absdk:check", "absdk:transparent"]);
    return Promise.all([...dialogImageIds].map(imageID => fetch(AbWebServices.getImageIdentifierManager().getImagePath(imageID))));
  }

  // Set up the static stateful class to have the appropriate strategy for defaulting the popup registry.
  static async configurePopupOwnerStrategy(importSpec) {
    importSpec = importSpec ?? ModuleLoaderUtils.createImportSpec(() => import("abreact/incubator/ui/app/router/DefaultPopupOwnerFn"), "defaultOwnerPopupFn");
    PopupUtils.ownerPopupRegistryDefaultFn = await ModuleLoaderUtils.import(importSpec);
  }
}
_AbReactServicesInitializer = AbReactServicesInitializer;
_defineProperty(AbReactServicesInitializer, "LOGGER", LogUtils.getLogger(__filename));
_defineProperty(AbReactServicesInitializer, "initializeFocusVisibleHandler", () => {
  const productDiv = document.querySelector(".ab-product");
  if (!productDiv) {
    _AbReactServicesInitializer.LOGGER.warn(".ab-product element not found to initialize focus visibility.");
    return;
  }
  const mouseDown = () => {
    if (!productDiv.classList.contains(AbReactConstants.FOCUS_VISIBLE_CLASS)) return;
    productDiv.classList.remove(AbReactConstants.FOCUS_VISIBLE_CLASS);
  };
  const keyDown = e => {
    if (productDiv.classList.contains(AbReactConstants.FOCUS_VISIBLE_CLASS) || e.altKey || e.ctrlKey || e.metaKey) return;
    productDiv.classList.add(AbReactConstants.FOCUS_VISIBLE_CLASS);
  };
  // eslint-disable-next-line abinitio/check-listeners
  productDiv.addEventListener("mousedown", mouseDown, {
    capture: true
  });
  // eslint-disable-next-line abinitio/check-listeners
  productDiv.addEventListener("keydown", keyDown, {
    capture: true
  });
});
//# sourceMappingURL=AbReactServicesInitializer.js.map
